import { render } from "./ProductosAdminView.vue?vue&type=template&id=555c5438&ts=true"
import script from "./ProductosAdminView.vue?vue&type=script&lang=ts"
export * from "./ProductosAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__